import { LANGUAGE_LEVEL } from '@src/shared/types/placement';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { FILTER_COLOR } from './filter-colors';

export const leadEnglishLevelFilterConfig = createSimpleFilterConfig({
  facetName: 'english_level',
  color: FILTER_COLOR.yellow,
  options: Object.values(LANGUAGE_LEVEL).map((engLvl) => ({
    label: formatTextForDisplay(engLvl),
    value: engLvl,
  })),
});
